<!--<div class="p-4" fxLayout="row" fxLayoutAlign="space-between center" mat-dialog-title><span>Download Contract</span></div>-->
<mat-dialog-content class="dialog-content p-0">
<!--  <div class="pr-5 pt-2 pb-2">-->
    <div class="loading" *ngIf="!quoteForm">
      <mat-spinner></mat-spinner>
    </div>
    <div class="details-con p-0">
      <div class="grid-con" fxLayout="row" *ngIf="quoteForm">
        <form [formGroup]="quoteForm" class="grid-inner-con" fxLayout="row" fxFlex="100">
          <!--        <ng-container *ngFor="let item of quoteFormData; let i=index">-->
          <mat-horizontal-stepper linear="true" class="w-100" #stepper>
            <mat-step>
              <ng-template matStepLabel>Step 1</ng-template>
              <div fxLayout="row wrap">
                <ng-container *ngFor="let quoteItem of quoteFormData; let i=index">
                  <div *ngIf="quoteItem.type == 'object'" [formGroupName]="quoteItem.field" fxFlex="100" fxLayout="row wrap" class="mb-3">
                    <h3 class="head mb-1" fxFlex="100">{{quoteItem.label}}</h3>
                    <div *ngFor="let item of quoteItem.items" class="gridItem p-1" [fxFlex]="10 * item.gridSize" fxLayout="column">
                      <label>{{item.label}}</label>
                      <mat-form-field *ngIf="item.type == 'string'" appearance="outline" [ngClass]="{'.w-100': true, 'disabled': item.disabled}" floatLabel="always">
                        <input [readonly]="item.disabled" matInput type="text" [formControlName]="item.field">
                      </mat-form-field>
                      <mat-form-field *ngIf="item.type == 'email'" appearance="outline" [ngClass]="{'.w-100': true, 'disabled': item.disabled}" floatLabel="always">
                        <input [readonly]="item.disabled" matInput type="email" email [formControlName]="item.field">
                      </mat-form-field>
                      <mat-form-field *ngIf="item.type == 'number'"  appearance="outline" class="w-100" floatLabel="always">
                        <input [readonly]="item.disabled" matInput type="number" [formControlName]="item.field">
                      </mat-form-field>
                      <mat-form-field *ngIf="item.type == 'date'" appearance="outline" floatLabel="always">
                        <input [readonly]="item.disabled" matInput [matDatepicker]="picker" [formControlName]="item.field">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                </ng-container>
              </div>
<!--              <div class="w-100 mt-2" fxLayout="row" fxLayoutAlign="end">-->
<!--                <button type="button" mat-raised-button color="accent" matStepperNext>Next</button>-->
<!--              </div>-->
  <!--            <div class="red-text mt-2">** Legal Entity Name, Due Date and Billing Address are required</div>-->
            </mat-step>
            <mat-step>
              <ng-template matStepLabel>Step 2</ng-template>
              <div class="w-100 mb-2" fxLayout="row" fxLayoutAlign="end">
<!--                {{getFormValue('taxExempt') ? 'Yes': 'No'}}-->
                <mat-slide-toggle *ngIf="market == 'ERCOT'" formControlName="taxExempt">Tax Exempt</mat-slide-toggle>
              </div>
              <ng-container *ngFor="let item of quoteFormData; let i=index">
                <div class="xScroll mt-2 mb-2 w-100" *ngIf="item.type == 'array' && quoteForm.controls[item.field]['controls'].length">
                  <table class="details-table w-100" fxFlex="100" cellpadding="0">
                    <thead>
                    <tr>
                      <ng-container *ngFor="let arrItem of item.items">
                      <th *ngIf="marketFieldBind(arrItem)">
                        <span>{{arrItem.type == 'button' ? '&#x00A0;' :arrItem.label}}</span>
                      </th>
                      </ng-container>
                    </tr>
                    </thead>
                    <tbody [formArrayName]="item.field">
                    <tr *ngFor="let formItem of quoteForm.controls[item.field]['controls']; let formInd = index" [formGroupName]="formInd">
                      <ng-container *ngFor="let arrItem of item.items">
                        <td *ngIf="marketFieldBind(arrItem)" align="center">
                        <ng-container *ngIf="arrItem.type == 'text'">
                          {{getFormValue(arrItem.field, item, formInd)}}
                        </ng-container>
                        <mat-form-field *ngIf="arrItem.type == 'select'" appearance="outline" class="w-100">
                          <mat-select [disabled]="(arrItem.disableOnValue && getFormValue(arrItem.field, item, formInd) && !arrItem.disableDependent) || arrItem.disableDependent && getFormValue(arrItem.disableDependent).length || false" [formControlName]="arrItem.field">
                            <mat-option *ngFor="let option of arrItem.dependency ? arrItem.options[getFormValue(arrItem.dependency, item, formInd)] || []: arrItem.options" [value]="option.value || option">
                              {{option.label || option}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field *ngIf="arrItem.type == 'string'"  appearance="outline" [ngClass]="{'w-100': true, 'disabled': arrItem.disabled}" floatLabel="always">
                          <input matInput [readonly]="arrItem.disabled" type="text" [formControlName]="arrItem.field">
                        </mat-form-field>
                        <mat-form-field *ngIf="arrItem.type == 'textarea'"  appearance="outline" class="w-100" floatLabel="always">
                          <textarea matInput rows="3" [formControlName]="arrItem.field"></textarea>
                        </mat-form-field>
                        <mat-form-field *ngIf="arrItem.type == 'date'" appearance="outline" floatLabel="always" class="w-100">
                          <!--              <mat-label>{{item.label}}</mat-label>-->
                          <input matInput [matDatepicker]="picker" [formControlName]="arrItem.field">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field *ngIf="arrItem.type == 'percent'" appearance="outline" floatLabel="always" class="w-100">
                          <mat-label>Font size</mat-label>
                          <input matInput type="number" placeholder="Ex. 10" [formControlName]="arrItem.field">
                          <span matSuffix>%</span>
                        </mat-form-field>
                        <mat-slide-toggle *ngIf="arrItem.type == 'toggle'" [formControlName]="arrItem.field">{{getFormValue(arrItem.field, item, formInd) ? 'Yes': 'No'}}</mat-slide-toggle>
                      </td>
                      </ng-container>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>
<!--              <div class="w-100 mt-2" fxLayout="row" fxLayoutAlign="space-between">-->
<!--                <button type="button" mat-raised-button color="accent" matStepperPrevious>Back</button>-->
<!--                <button type="button" mat-raised-button color="accent" [disabled]="quoteForm.invalid">Submit</button>-->
<!--              </div>-->
            </mat-step>
          </mat-horizontal-stepper>
          <!--        </ng-container>-->

        </form>
      </div>
    </div>
<!--  </div>-->
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div *ngIf="quoteForm" fxLayout="row" fxLayoutAlign="space-between center" class="w-100 action-btns">
<!--    <button mat-button mat-raised-button color="primary" class="invisible" *ngIf="stepperIndex == 0" (click)="closeDialog()">Close</button>-->
    <div class="red-text mr-2" *ngIf="stepperIndex == 0">* Fixed Price, Terms, Name, Title, Phone, Email, Street, City, State and Zipcode are required</div>
    <button type="button" mat-raised-button color="primary" (click)="nextStepper()" *ngIf="stepperIndex == 0" [disabled]="quoteForm.controls['pricing'].invalid || quoteForm.controls['customerInfo'].invalid || quoteForm.controls['address'].invalid">Next</button>
    <button type="button" mat-raised-button color="primary" (click)="prevStepper()" *ngIf="stepperIndex == 1" [disabled]="downloadInProgress">Back</button>
    <button type="button" mat-raised-button color="primary" *ngIf="stepperIndex == 1" [disabled]="quoteForm.invalid || downloadInProgress" (click)="submitForm()">
      <ng-container *ngIf="downloadInProgress">
        <mat-icon><mat-spinner diameter="20"></mat-spinner></mat-icon>
      </ng-container>
      {{downloadInProgress ? 'Downloading' : 'Download'}}
    </button>
  </div>
</mat-dialog-actions>
